import { render } from "./Menu.vue?vue&type=template&id=f1ca3bb2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=f1ca3bb2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ca3bb2"]])

export default __exports__